import React, { Component } from "react";
import { Text, Animated, View, StyleSheet } from "react-native";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";

import { StyleContext } from "app/contexts/Style";

export default class AnimatedEllipsis extends Component {
  static contextType = StyleContext;
  static propTypes = {
    numberOfDots: PropTypes.number,
    animationDelay: PropTypes.number,
    minOpacity: PropTypes.number,
    color: PropTypes.string,
  };

  static defaultProps = {
    numberOfDots: 3,
    animationDelay: 300,
    minOpacity: 0,
    // color: "#aaa",
    style: {
      // color: "#aaa",
      fontSize: 32,
    },
  };

  constructor(props) {
    super(props);

    this._animation_state = {
      dot_opacities: this.initializeDots(),
      target_opacity: 1,
      should_animate: true,
    };
  }

  initializeDots() {
    let opacities = [];

    for (let i = 0; i < this.props.numberOfDots; i++) {
      let dot = new Animated.Value(this.props.minOpacity);
      opacities.push(dot);
    }

    return opacities;
  }

  componentDidMount() {
    this.animate_dots.bind(this)(0);
  }

  componentWillUnmount() {
    this._animation_state.should_animate = false;
  }

  animate_dots(which_dot) {
    if (!this._animation_state.should_animate) return;

    // swap fade direction when we hit end of list
    if (which_dot >= this._animation_state.dot_opacities.length) {
      which_dot = 0;
      let min = this.props.minOpacity;
      this._animation_state.target_opacity =
        this._animation_state.target_opacity == min ? 1 : min;
    }

    let next_dot = which_dot + 1;

    Animated.timing(this._animation_state.dot_opacities[which_dot], {
      toValue: this._animation_state.target_opacity,
      duration: this.props.animationDelay,
      useNativeDriver: !ENV.WEB,
    }).start(this.animate_dots.bind(this, next_dot));
  }

  render() {
    let dots = this._animation_state.dot_opacities.map((o, i) => (
      <Animated.View
        key={i}
        style={[
          this.props.style,
          this.styles().dot,
          {
            backgroundColor: this.props.color || this.context.colors.foreground,
            opacity: o,
            transform: [
              {
                translateY: -1.5,
              },
              {
                scale: o,
              },
            ],
          },
        ]}
      />
    ));

    return <View style={this.styles().container}>{dots}</View>;
  }

  styles = () => ({
    container: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: 50,
      height: this.context.sizes.default * 1.4,
      opacity: 0.6,
    },
    dot: {
      width: 4,
      height: 4,
      borderRadius: 99,
      // marginTop: 10,
      // marginBottom: 5,
      marginHorizontal: 4,
    },
  });
}
